import {createNode} from "./common/ui";

(function () {
	function initPopShops() {
		function initUi() {
			let carousel;
			let categoryChangedHandler;
			let shopCategoryButtons = getShopCategoryButtons();

			const shopCategoriesContainer = document.querySelector('.sys__shops-categories');
			const shopCountriesRadios = document.querySelectorAll('[name=countries__country]');
			const shopListContainer = document.querySelector('.sys__shops-list');
			const bulletsContainer = document.querySelector('.sys__pop-shop-bullets');

			function mountCarousel() {
				carousel = new Glide(
					'.sys__popular-shops-carousel',
					{
						type: 'carousel',
						autoplay: false,
						perView: 6,
						perTouch: 4,
						breakpoints: {
							1039: {perView: 3, perTouch: 3},
							799: {perView: 2, perTouch: 2},
							320: {perView: 1, perTouch: 1}
						}
					}
				).mount();
			}

			function shopCategoryNodeFrom(category) {
				const result = createNode('li');
				const link = createNode(
					'a',
					'pop-shops__category-link sys__shop-category-button',
					{
						href: '/',
						innerText: category.name,
					}
				)
				link.setAttribute('data-category-id', category.id);

				result.appendChild(link);

				return result;
			}

			function shopShopNodeFrom(shop) {
				const li = createNode('li');
				const card = shop.hasDetailedPage
					? createNode(
						'a',
						'pop-shops__featured-shop',
						{
							href: `/shops/${shop.id}.html`,
						})
					: createNode(
						'a',
						'pop-shops__featured-shop',
						{
							href: `${shop.link}`,
							target: '_blank',
						})
				li.appendChild(card);
				const logoPicture = createNode('picture');
				const logoSource = createNode(
					'source',
					undefined,
					{
						srcset: `/images/webp/shops/${shop.logoWebp}, /images/webp/shops/${shop.logoWebp2x} 2x, /images/webp/shops/${shop.logoWebp3x} 3x`,
						type: 'image/webp'
					}
				);
				const logoImg = createNode(
					'img',
					'pop-shops__shop-logo',
					{
						src: `/images/shops/${shop.logo}`,
						srcset: `/images/shops/${shop.logo}, /images/shops/${shop.logo2x} 2x, /images/shops/${shop.logo3x} 3x`,
						alt: shop.name
					}
				)
				logoPicture.appendChild(logoSource);
				logoPicture.appendChild(logoImg);
				const logoFrame = createNode('div', 'pop-shops__shop-logo-frame');
				if (!!shop.vpn) {
					const vpnBadge = createNode('span', 'pop-shops__shop-logo-badge', {innerText: 'VPN'})
					logoFrame.appendChild(vpnBadge)
				}
				logoFrame.appendChild(logoPicture);
				const shopName = createNode('p', 'pop-shops__shop-name', {innerText: shop.name});
				const gotoShopLink = createNode(
					'span',
					'button button--primary button--accent pop-shops__to-shop',
					{
						innerText: 'В магазин',
					});
				card.appendChild(logoFrame);
				card.appendChild(shopName);
				card.appendChild(gotoShopLink);
				return card;
			}

			function allCategoryShopsNodeFrom(categoryId) {
				const li = createNode('li');
				const card = createNode(
					'a',
					'pop-shops__featured-shop pop-shops__featured-shop--all-category-shops',
					{
						href: `/shops.html#${categoryId}`,
						target: '_blank',
					}
				);
				li.appendChild(card);
				const logoImg = createNode(
					'img',
					'pop-shops__shop-logo',
					{
						src: '/images/bag-3d.png',
						srcset: '/images/bag-3d.png, /images/bag-3d--2x.png 2x, /images/bag-3d--3x.png 3x'
					}
				)
				const logoFrame = createNode('div', 'pop-shops__shop-logo-frame pop-shops__shop-logo-frame--all-category-shops');
				logoFrame.appendChild(logoImg);
				const shopName = createNode('p', 'pop-shops__shop-name', {innerText: 'Все магазины'});
				const gotoShopLink = createNode(
					'span',
					'button button--primary button--primary-color pop-shops__to-shop',
					{
						innerText: 'В магазин',
					}
				);
				card.appendChild(logoFrame);
				card.appendChild(shopName);
				card.appendChild(gotoShopLink);
				return card;
			}

			function bulletNodeWith(index) {
				const button = createNode(
					'button',
					'pop-shops__carousel-bullet glide__bullet',
					{
						ariaLabel: `Slide ${index}`,
					},
				);
				button.dataset.glideDir = `=${index}`;
				return button;
			}

			function getShopCategoryButtons() {
				return document.querySelectorAll('.sys__shop-category-button');
			}

			function setCurrentCategoryButton(currentButton) {
				for (let categoryButton of shopCategoryButtons) {
					categoryButton.classList.toggle('pop-shops__category-link--active', categoryButton === currentButton);
				}
			}

			function getCountryIsoCode() {
				return [...shopCountriesRadios].filter(radioButton => radioButton.checked).map(radioButton => radioButton.value)[0];
			}

			function loadShops(categoryButton) {
				const categoryId = categoryButton.attributes['data-category-id'].value;
				categoryChangedHandler(getCountryIsoCode(), categoryId)
					.then(() => {
						setCurrentCategoryButton(categoryButton)
					});
			}

			function onCategoryClick() {
				for (let categoryButton of shopCategoryButtons) {
					categoryButton.addEventListener('click', function (event) {
						event.preventDefault();
						loadShops(categoryButton);
					});
				}
			}

			return {
				mountCarousel: mountCarousel,
				unmountCarousel: function () {
					if (!carousel) {
						throw new Error('nothing to destroy');
					}
					carousel.destroy();
					carousel = undefined;
				},
				onCategoryClick: onCategoryClick,
				onCountryClick: function (eventHandler) {
					for (let countryRadio of shopCountriesRadios) {
						countryRadio.addEventListener('change', function (event) {
							eventHandler(getCountryIsoCode())
								.then(() => {
									onCategoryClick();
									loadShops(shopCategoryButtons[0]);
								});
						});
					}
				},
				replaceShopsWith: function (newShopsList, categoryId) {
					shopListContainer.innerHTML = '';
					bulletsContainer.innerHTML = '';
					const length = newShopsList.length;
					for (let index = 0; index < length; index++) {
						shopListContainer.appendChild(shopShopNodeFrom(newShopsList[index]));
						bulletsContainer.appendChild(bulletNodeWith(index));
					}
					shopListContainer.appendChild(allCategoryShopsNodeFrom(categoryId))
				},
				replaceCategoriesWith: function (newCategoriesList) {
					shopCategoriesContainer.innerHTML = '';
					for (let category of newCategoriesList) {
						shopCategoriesContainer.appendChild(shopCategoryNodeFrom(category));
					}
					shopCategoryButtons = getShopCategoryButtons();
				},
				onCategoryChanged: function (newCategoryChangedHandler) {
					categoryChangedHandler = newCategoryChangedHandler;
				}
			};
		}

		function initApi() {
			const random = Math.floor(Math.random() * 10000000000000000);
			return {
				fetchCategories: function (countryIsoCode) {
					return new Promise((resolve, reject) => {
						fetch(`/get/${countryIsoCode}/shopsCategories.json?${random}`)
							.then(response => {
								response.json().then(resolve).catch(reject);
							})
							.catch(reject);
					});
				},
				fetchShops: function (countryIsoCode, categoryId) {
					return new Promise((resolve, reject) => {
						fetch(`/get/${countryIsoCode}/popular-shops__${categoryId}.json?${random}`)
							.then(response => {
								response.json().then(resolve).catch(reject);
							})
							.catch(reject);
					});
				}
			};
		}

		function initBehaviour(ui, api) {
			ui.mountCarousel();
			ui.onCategoryClick();
			ui.onCategoryChanged(function (countryIsoCode, categoryId) {
				return new Promise((resolve) => {
						api.fetchShops(countryIsoCode, categoryId)
							.then(shops => {
								ui.unmountCarousel();
								ui.replaceShopsWith(shops, categoryId);
								ui.mountCarousel();
								resolve();
							});
						// .catch(error => {
						// 	console.error('API call failed', error);
						// });
					}
				);
			});
			ui.onCountryClick(function (countryIsoCode) {
				return new Promise((resolve) => {
					api.fetchCategories(countryIsoCode)
						.then(categories => {
							ui.replaceCategoriesWith(categories);
							resolve();
						})
				})
			});
		}

		const ui = initUi();
		const api = initApi();
		initBehaviour(ui, api);
	}

	document.addEventListener('DOMContentLoaded', function () {
		initPopShops();
	});
})();
